import { render, staticRenderFns } from "./morelist.vue?vue&type=template&id=24c708b0"
import script from "./morelist.vue?vue&type=script&lang=js"
export * from "./morelist.vue?vue&type=script&lang=js"
import style0 from "./morelist.vue?vue&type=style&index=0&id=24c708b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports